import type { SaveData } from "./types.js";

const PREFIX = "trash-panic:save:";

export async function saveSlot(slotId: string, data: SaveData): Promise<void> {
  try {
    localStorage.setItem(PREFIX + slotId, JSON.stringify(data));
  } catch {
    /* quota / private mode */
  }
}

export async function loadSlot(slotId: string): Promise<SaveData | null> {
  try {
    const raw = localStorage.getItem(PREFIX + slotId);
    if (!raw) return null;
    return JSON.parse(raw) as SaveData;
  } catch {
    return null;
  }
}
